export default __webpack_public_path__ + "static/media/shrink_work.5e09cd90.png";